__turbopack_context__.v({
  "layoutRestricted": "RegistrationLayout-module__3Mw_oG__layoutRestricted",
  "mainContainer": "RegistrationLayout-module__3Mw_oG__mainContainer",
});
